type TrackPageViewInput = {
  href: string;
  pathname: string;
  search: string;
};

type PrivacyAwareNavigator = Navigator & {
  globalPrivacyControl?: boolean;
};

const shouldTrack = () => {
  if (process.env.NODE_ENV !== "production") {
    return false;
  }

  if (typeof window === "undefined") {
    return false;
  }

  if (window.location.hostname === "localhost") {
    return false;
  }

  const privacyAwareNavigator = navigator as PrivacyAwareNavigator;

  if (
    privacyAwareNavigator.doNotTrack === "1" ||
    privacyAwareNavigator.globalPrivacyControl
  ) {
    return false;
  }

  return true;
};

export const trackPageView = (location: TrackPageViewInput) => {
  if (!shouldTrack()) {
    return;
  }

  const payload = JSON.stringify({
    path: `${location.pathname}${location.search}`,
    referrer: document.referrer,
    title: document.title,
  });

  if (navigator.sendBeacon) {
    const blob = new Blob([payload], { type: "application/json" });
    navigator.sendBeacon("/api/track", blob);
    return;
  }

  void fetch("/api/track", {
    body: payload,
    headers: {
      "Content-Type": "application/json",
    },
    keepalive: true,
    method: "POST",
  });
};
